import { ComboBox } from 'src/components/credit/ui/comboBox/ComboBox';
import { IIncome } from '../IndividualOccupationIncome';
import { useCreditForm } from 'src/customHooks/useCreditForm';
import { useLocalization } from '../../../../../utils/useLocalization';
import { validateRangeCeroToNineNineNine } from '../../utils';
import React, { useEffect, useState } from 'react';

const ZERO = 0;
const ONE = 1;

const optionsFrequency = {
    MONTHLY: 'Monthly',
    HOURLY: 'Hourly',
    WEEKLY: 'Weekly',
    EVERY2WEEKS: 'Every2Weeks',
    BIMONTHLY: 'BiMonthly',
    ANNUAL: 'Annual',
};

interface IProps {
    handlerChangeItems?: Function;
    incomeError?: boolean;
    isDisabled?: boolean;
    initialIncomes?: any;
    isEditMode: boolean;
    setFieldValueUpdated: Function;
}

const Income = ({
    handlerChangeItems,
    incomeError = false,
    isDisabled = false,
    initialIncomes = null,
    isEditMode = false,
    setFieldValueUpdated,
}: IProps) => {
    const { occupationIndividualInformation } = useLocalization();
    const { markCreditFormTouched } = useCreditForm();
    const optionsFrecuencyTitle = {
        Monthly: occupationIndividualInformation.INCOME_MONTHLY,
        Hourly: occupationIndividualInformation.INCOME_HOURLY,
        Weekly: occupationIndividualInformation.INCOME_WEEKLY,
        Every2Weeks: occupationIndividualInformation.INCOME_EVERY_2_WEEKS,
        BiMonthly: occupationIndividualInformation.INCOME_BI_MONTHLY,
        Annual: occupationIndividualInformation.INCOME_ANNUAL,
    };
    const [incomes, setIncomes] = useState<IIncome[]>([
        {
            frequency: optionsFrequency.MONTHLY,
            amount: null,
            type: 'Employment',
        },
    ]);

    const [amount] = useState(ZERO);
    const [errorAmount, setErrorAmount] = useState(false);

    useEffect(() => {
        if (validateRangeCeroToNineNineNine(amount)) {
            setErrorAmount(true);
        } else setErrorAmount(false);
    }, [amount]);

    useEffect(() => {
        if (handlerChangeItems) {
            handlerChangeItems(incomes);
        }
    }, [incomes]);

    //for edit mode
    useEffect(() => {
        if (!initialIncomes) {
            if (isEditMode && handlerChangeItems) {
                setFieldValueUpdated(true);
            }
            return;
        }
        let applicantIncomes = [];

        if (Array.isArray(initialIncomes)) {
            applicantIncomes = initialIncomes.map((income) => {
                const newIncome = {
                    frequency:
                        income?.IncomeFrequency ?? optionsFrequency.MONTHLY,
                    amount: income?.GrossAmount ?? null,
                    type: income?.IncomeType ?? 'Employment',
                };
                return newIncome;
            });
        } else {
            const newIncome = {
                frequency:
                    initialIncomes?.IncomeFrequency ?? optionsFrequency.MONTHLY,
                amount: initialIncomes?.GrossAmount ?? null,
                type: initialIncomes?.IncomeType ?? 'Employment',
            };

            applicantIncomes.push(newIncome);
        }
        setIncomes(applicantIncomes);
        if (isEditMode && handlerChangeItems) {
            handlerChangeItems(applicantIncomes);
            setFieldValueUpdated(true);
        }
    }, []);

    /**
     * To check if the other income data is available in income list
     */
    const hasOtherIncome = incomes.some(
        (income) => income.type === 'OtherIncome',
    );

    return (
        <div className={'income'}>
            <div className='o-fieldset__row mb-0'>
                <div className='o-layout'>
                    <div className='o-layout__item  u-1/1  u-1/1@xs '>
                        <p>
                            <strong>
                                {occupationIndividualInformation.INCOME}
                            </strong>
                        </p>
                    </div>
                </div>
            </div>
            <div className={' income-list'}>
                {incomes.length
                    ? incomes.map((ele, key) => {
                          const showAmountError =
                              ele.error || (incomeError && ele.amount === null);
                          return (
                              <div key={key}>
                                  <div className='o-fieldset__row'>
                                      <div className='o-layout'>
                                          <div className='o-layout__item  u-1/2  u-1/1@xs'>
                                              <div className='c-form-field'>
                                                  <label
                                                      htmlFor='m1l7e063'
                                                      className='c-form-field__label'
                                                  >
                                                      {
                                                          occupationIndividualInformation.FEQUENCY
                                                      }
                                                      *
                                                  </label>
                                                  <div className='c-form-field__box'>
                                                      <ComboBox
                                                          name={'frequency'}
                                                          options={[
                                                              {
                                                                  label: optionsFrecuencyTitle.Monthly,
                                                                  value: optionsFrequency.MONTHLY,
                                                              },
                                                              {
                                                                  label: optionsFrecuencyTitle.Weekly,
                                                                  value: optionsFrequency.WEEKLY,
                                                              },
                                                              {
                                                                  label: optionsFrecuencyTitle.Every2Weeks,
                                                                  value: optionsFrequency.EVERY2WEEKS,
                                                              },
                                                              {
                                                                  label: optionsFrecuencyTitle.BiMonthly,
                                                                  value: optionsFrequency.BIMONTHLY,
                                                              },
                                                              {
                                                                  label: optionsFrecuencyTitle.Annual,
                                                                  value: optionsFrequency.ANNUAL,
                                                              },
                                                          ]}
                                                          defaultValue={
                                                              optionsFrequency.MONTHLY
                                                          }
                                                          placeholder={''}
                                                          selectedOption={
                                                              ele.frequency
                                                          }
                                                          onSelect={(value) => {
                                                              setIncomes(
                                                                  (
                                                                      oldValues,
                                                                  ) => {
                                                                      const aux =
                                                                          [
                                                                              ...oldValues,
                                                                          ];
                                                                      aux[
                                                                          key
                                                                      ].frequency =
                                                                          value;
                                                                      return aux;
                                                                  },
                                                              );
                                                              markCreditFormTouched();
                                                          }}
                                                          disabled={isDisabled}
                                                      />
                                                  </div>
                                              </div>
                                          </div>
                                          <div className='o-layout__item  u-1/2  u-1/1@xs'>
                                              <div className='c-form-field'>
                                                  <label
                                                      htmlFor='m1l7e063'
                                                      className='c-form-field__label'
                                                  >
                                                      {
                                                          occupationIndividualInformation.GROSS_AMOUNT
                                                      }
                                                      *
                                                  </label>
                                                  <div className='c-form-field__box'>
                                                      <div className='c-input align-items'>
                                                          <span>$</span>
                                                          <input
                                                              className={`c-input__input ${
                                                                  showAmountError
                                                                      ? 'is-error'
                                                                      : ''
                                                              }`}
                                                              type='number'
                                                              name='grossIncome'
                                                              placeholder=''
                                                              value={
                                                                  ele.amount ===
                                                                  null
                                                                      ? ''
                                                                      : ele.amount.toString()
                                                              }
                                                              onChange={(
                                                                  event,
                                                              ) => {
                                                                  const isNegative =
                                                                      event.target.value
                                                                          .trim()
                                                                          .startsWith(
                                                                              '-',
                                                                          );
                                                                  let value =
                                                                      event
                                                                          .target
                                                                          .value;
                                                                  value =
                                                                      value.replace(
                                                                          /[^\d.]/g,
                                                                          '',
                                                                      );
                                                                  const parts =
                                                                      value.split(
                                                                          '.',
                                                                      );
                                                                  const int =
                                                                      parts[0] ||
                                                                      '';
                                                                  const dec =
                                                                      parts[1] ||
                                                                      '';
                                                                  const formatted =
                                                                      int +
                                                                      (value.includes(
                                                                          '.',
                                                                      )
                                                                          ? '.' +
                                                                            // eslint-disable-next-line no-magic-numbers
                                                                            dec.slice(
                                                                                // eslint-disable-next-line no-magic-numbers
                                                                                0,
                                                                                // eslint-disable-next-line no-magic-numbers
                                                                                2,
                                                                            )
                                                                          : '');
                                                                  const parsed =
                                                                      Number(
                                                                          formatted,
                                                                      );
                                                                  const signedValue =
                                                                      isNegative
                                                                          ? -parsed
                                                                          : parsed;
                                                                  const num =
                                                                      formatted ===
                                                                      ''
                                                                          ? null
                                                                          : signedValue;
                                                                  // eslint-disable-next-line no-magic-numbers
                                                                  if (
                                                                      num !==
                                                                          null &&
                                                                      !isNaN(
                                                                          num,
                                                                      ) &&
                                                                      num >
                                                                          // eslint-disable-next-line no-magic-numbers
                                                                          999999.99
                                                                  )
                                                                      return;
                                                                  setIncomes(
                                                                      (
                                                                          oldValues,
                                                                      ) => {
                                                                          const aux =
                                                                              [
                                                                                  ...oldValues,
                                                                              ];
                                                                          aux[
                                                                              key
                                                                          ].amount =
                                                                              num;
                                                                          aux[
                                                                              key
                                                                          ].error =
                                                                              num !==
                                                                                  null &&
                                                                              num <
                                                                                  ZERO;
                                                                          return aux;
                                                                      },
                                                                  );
                                                                  markCreditFormTouched();
                                                              }}
                                                              min={0}
                                                              max={999999.99}
                                                          />
                                                      </div>
                                                      <div>
                                                          {showAmountError ? (
                                                              <span
                                                                  className={
                                                                      'c-error-message'
                                                                  }
                                                                  style={{
                                                                      position:
                                                                          'absolute',
                                                                  }}
                                                              >
                                                                  {
                                                                      occupationIndividualInformation.VALID_AMOUNT_ERR
                                                                  }
                                                              </span>
                                                          ) : null}
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                          <div className='o-layout__item  u-1/10  u-1/1@xs'>
                                              {key === Number('0') ? (
                                                  <button
                                                      className='c-btn c-btn--secondary'
                                                      type='button'
                                                      disabled={
                                                          errorAmount ||
                                                          hasOtherIncome
                                                      }
                                                      onClick={() => {
                                                          setIncomes([
                                                              ...incomes,
                                                              {
                                                                  amount: null,
                                                                  type: 'OtherIncome',
                                                                  frequency:
                                                                      optionsFrecuencyTitle.Monthly,
                                                              },
                                                          ]);
                                                          markCreditFormTouched();
                                                      }}
                                                  >
                                                      <span className='c-btn__text'>
                                                          {
                                                              occupationIndividualInformation.ADD_OTHER_INCOME
                                                          }
                                                      </span>
                                                  </button>
                                              ) : (
                                                  <button
                                                      className='c-btn c-btn--secondary'
                                                      type='button'
                                                      onClick={() => {
                                                          setIncomes(
                                                              (oldValue) => {
                                                                  const aux = [
                                                                      ...oldValue,
                                                                  ];
                                                                  aux.splice(
                                                                      key,
                                                                      ONE,
                                                                  );
                                                                  return aux;
                                                              },
                                                          );
                                                          markCreditFormTouched();
                                                      }}
                                                  >
                                                      <span className='c-btn__text'>
                                                          {
                                                              occupationIndividualInformation.DEL_OTHER_INCOME
                                                          }
                                                      </span>
                                                  </button>
                                              )}
                                          </div>
                                      </div>
                                  </div>
                                  <br />
                                  <hr></hr>
                              </div>
                          );
                      })
                    : null}
            </div>
        </div>
    );
};

export default Income;
